export default "__VITE_ASSET__wDUBWy8i__"